import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';

type NewRequestFormData = {
  direction: string;
  trailerVrn: string;
  tractorVrn: string;
  vehicleNationality?: string;
  crossingRequestedDate: string;
  requiresGmrFormality?: boolean;
  internalClientReference: string;
  requiresGmrAndEloFormality?: boolean;
};

type UpdateCrossingRequestedDateType = {
  folderTypologyId: string;
  data: NewRequestFormData;
};

const carrierId = 'B112831C-A0D4-11EE-8C90-0242AC120002';
const openCustomsAndCrossingServiceId = '11A27116-A0D4-11EE-8C90-0242AC120002';

const createNewBorderCrossingRoroRequest = ({ data, folderTypologyId }: UpdateCrossingRequestedDateType) =>
  axios.post<string>(`/folder-typologies/${folderTypologyId}/folders`, {
    ...data,
    carrierId,
    borderCrossingServiceId: openCustomsAndCrossingServiceId,
  });

export const useCreateNewBorderCrossingRoroRequestAsync = () =>
  useMutation({
    mutationFn: createNewBorderCrossingRoroRequest,
  });
